import { EventTypes } from 'redux-segment';

export type ModalType =
  | 'GET_THE_APP_DRAWER'
  | 'INSURANCE_MODAL'
  | 'ONBOARDING_MODAL'
  | 'ONBOARDING_RESUME_MODAL'
  | 'PHI_AUTH_MODAL'
  | 'PHOTO_ID_UPLOAD_MODAL'
  | 'POST_DELIVERY_MODAL';

export function openModal(modalType: ModalType, props?: Record<string, unknown>) {
  return {
    type: 'OPEN_MODAL',
    payload: {
      type: modalType,
      props,
    },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'OPEN_MODAL',
          properties: {
            modalType,
          },
        },
      },
    },
  } as const;
}

export function closeModal(modalType: ModalType | null) {
  return {
    type: 'CLOSE_MODAL',
    payload: modalType,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'CLOSE_MODAL',
          properties: {
            modalType,
          },
        },
      },
    },
  } as const;
}

export function changeModalStep(step: number, modalType: ModalType) {
  return {
    type: 'CHANGE_MODAL_STEP',
    payload: step,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'CHANGE_MODAL_STEP',
          properties: {
            modalType,
            step,
          },
        },
      },
    },
  } as const;
}

export function nextModalStep(modalType: ModalType) {
  return {
    type: 'NEXT_MODAL_STEP',
    payload: modalType,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'NEXT_MODAL_STEP',
          properties: {
            modalType,
          },
        },
      },
    },
  } as const;
}

export function previousModalStep(modalType: ModalType) {
  return {
    type: 'PREVIOUS_MODAL_STEP',
    payload: modalType,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'PREVIOUS_MODAL_STEP',
          properties: {
            modalType,
          },
        },
      },
    },
  } as const;
}

export function openOriginModal() {
  return {
    type: 'OPEN_ORIGIN_MODAL',
  } as const;
}
